import React, { memo } from "react";
import AtivoProvider from "../../../contexts/AtivosContext";
import EmpresaProvider from "../../../contexts/EmpresasContext";
import AtivoOverview from "./AtivoOverview";

const Ativo = memo(() => {
  return (
    <AtivoProvider>
      <AtivoOverview />
    </AtivoProvider>
  );
});

export default Ativo;
